require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bic-and-partners-brief-congress-on-the-idb.json") })
        }
      }, "path---en-us-update-bic-and-partners-brief-congress-on-the-idb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bic-and-partners-brief-congress-on-the-idb!./.cache/json/en-us-update-bic-and-partners-brief-congress-on-the-idb.json
// module id = 622
// module chunks = 231608221292675